<template>
    <form @submit.prevent="submit" :class="{ submitting: submitted }">
        <img class="img-fluid mb-4 w-75" :src="defaultLogoUrl" :alt="defaultCompanyAlias" srcset="">
        <p class="h3 mb-3">{{ i18n('Two-Step Verification') }}</p>
        <div class="text-center alert alert-danger" v-if="errorMessage">{{ errorMessage }}</div>
        <p class="text-sm text-gray-600 mb-4 text-center">
            {{ i18n('Please enter the verification code shown in your app.') }}
        </p>
        <div class="row g-2 mb-2">
            <div class="col-12">
                <Field :label="i18n('auth code')" type="text" placeholder="0000" v-model="formData.code"
                    :disabled="submitted" />
            </div>
        </div>
        <div class="d-grid mb-3 mt-4">
            <button type="submit" class="btn btn-dark btn-dark-petrol" :disabled="submitted">
                <span v-if="submitted" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden"> {{ i18n('Sending ...') }}</span>
                </span>
                {{ i18n('Log In') }}
            </button>
        </div>
        <div class="d-grid mb-3 mt-1 small">
            <a href="javascript:void(0)" class="" @click="sendEmail">
                {{ i18n('I don\'t have access to my app, send me a code by email.') }}
            </a>
        </div>
    </form>
</template>
<script>

import api from "@/api.js";
import Field from "@/components/common/form/Field.vue";
import { translatedErrorMessage, } from "@/tools/errorHandling.js";
import $env from "@/tools/environment.js";
const defaultLogoUrl = $env('VITE_DEFAULT_LOGO_URL');
const defaultCompanyAlias = $env('VITE_DEFAULT_COMPANY_ALIAS');
const loginImagePath = $env('VITE_DEFAULT_LOGIN_IMAGE');

export default {
    components: {
        Field,
    },
    data() {
        return {
            errorMessage: null,
            loginImagePath,
            defaultLogoUrl,
            submitted: false,
            defaultCompanyAlias,
            formData: {},
            urlParams: {},
        };
    },
    props: {
        username: {
            type: String,
            default: null,
        },
    },
    created() {
        this.urlParams = Object.fromEntries(new URLSearchParams(window.location.search));
    },
    emits: ['verified'],
    methods: {
        submit() {
            api.post('login/ad/2fa/verify', { 
                'email': this.username, 
                'code': this.formData.code, 
                'client_id': this.$route.query.client_id, 
                ...this.urlParams 
            }).then(codeResult => {
                if (codeResult?.cookie) {
                    this.$emit('verified', codeResult);
                } else {
                    this.errorMessage = this.i18n('Invalid code. Please try again.');
                }
            }).catch(exception => {
                this.errorMessage = translatedErrorMessage(exception.response.message);
            });
        },
        sendEmail() {
            api.post('login/ad/2fa/sendEmail', { 'email': this.username }).then(response => {
                this.$root.showSuccessModal( this.i18n('Email sent'), this.i18n('A new code has been sent to your email address.'));
            }).catch(exception => {
                if (exception?.response?.message) {
                    this.$root.showErrorModal( this.i18n('Error'), translatedErrorMessage(exception.response.message));
                } else {
                    this.$root.showErrorModal( this.i18n('Error'), this.i18n('An error occurred while sending the email.'));
                }
            });
        },
    },
}

</script>

<style lang="scss" scoped>
form {
    max-width: 320px;
}
</style>
